import { createFileRoute, redirect } from "@tanstack/react-router";

import { ProjectChatVariant } from "@/pages/projects/components/project/chat/constants";

export const Route = createFileRoute("/_secure/projects/$projectId/")({
  beforeLoad: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: "/projects/$projectId/graph",
      params: { projectId: params.projectId },
      search: { chat: ProjectChatVariant.PANEL },
    });
  },
});
